import { Heading1, P, Stack } from "@ovotech/element";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Page } from "_core/components";
import { ProductUrls } from "_core/types";
import CheckmarkIcon from "_assets/checkmark.svg";
import { fetchVerifyEmail } from "_core/utils";
import { useConfig } from "_core/utils/config";
import { LoadingSkeleton } from "_core/components/LoadingSkeleton";
import { useStore } from "_core/store";
import { PhoneContact } from "_core/components/PhoneContact";
import { EmailContact } from "_core/components/EmailContact";

const EmailConfirmationPageContent = () => {
  const { verificationCode } = useStore();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { API_URL } = useConfig();

  useEffect(() => {
    setLoading(true);

    if (verificationCode) {
      fetchVerifyEmail(verificationCode, navigate, setLoading, API_URL);
    }

    return () => {
      setLoading(false);
    };
  }, [API_URL, navigate, setLoading, verificationCode]);

  return loading ? (
    <LoadingSkeleton />
  ) : (
    <>
      <Stack spaceBetween={4}>
        <CheckmarkIcon />
        <Heading1 className={"SurfaceHeading"}>
          Thanks for confirming your email address.
        </Heading1>
        <P size={"lg"}>
          A text message with the link to your installation survey is on its
          way.
        </P>
        <P size={"lg"}>
          It might take a few minutes for the text message to come through. Once
          you’ve got it, use the link to start your installation survey.
        </P>
        <P size={"lg"}>
          If you have any questions, give us a call on <PhoneContact />, or
          email us at <EmailContact />.
        </P>
      </Stack>
    </>
  );
};

export const EmailConfirmationPage = () => {
  return (
    <Page title="" subtitle="" url={ProductUrls.EmailConfirmation}>
      <EmailConfirmationPageContent />
    </Page>
  );
};
